import { DataNode } from '@/types';
import { CELL_STYLE_MAP, ROW_DEPTH_STYLES, FILTER_TAG_MAP, HEADER_CLASS_NAMES } from './ReconciliationTable.constants';

/**
 * Get cell style class based on column type
 */
export const getCellStyle = (value: number, columnType: string): string => {
  return CELL_STYLE_MAP[columnType] || CELL_STYLE_MAP.default;
};

/**
 * Get row style class based on node tag and depth
 */
export const getRowStyle = (nodeTag: string, depth: number): string => {
  const depthStyle = ROW_DEPTH_STYLES[depth.toString()] || ROW_DEPTH_STYLES.default;
  return depthStyle;
};

/**
 * Get header class name based on header ID
 */
export const resolveHeaderClassName = (headerId: string): string => {
  return HEADER_CLASS_NAMES[headerId] || HEADER_CLASS_NAMES.default;
};

/**
 * Format date to dd/mm/yyyy
 */
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

/**
 * Get cumulative variance tooltip text
 */
export const getCumulativeTooltipText = (
  calculatedCumilativeFromDate: string | null | undefined,
  businessDay: string | undefined,
  cumulativeFromDate: string | null | undefined
): string => {
  if (!calculatedCumilativeFromDate || !businessDay) return '';
  
  const fromDate = calculatedCumilativeFromDate || cumulativeFromDate;
  return `${fromDate ? formatDate(fromDate) : '...'} - ${formatDate(businessDay)}`;
};

/**
 * Filter data by NodeTag and NodeLabel recursively
 */
export function filterDataByNodeTag(
  data: DataNode[],
  filterTag: string,
  filterValues: string[]
): DataNode[] {
  const targetNodeTag = FILTER_TAG_MAP[filterTag];
  if (!targetNodeTag) return data;

  return data.filter(node => {
    // Check if current node matches the filter
    if (node.NodeTag === targetNodeTag && filterValues.includes(node.NodeLabel)) {
      return true;
    }

    // Recursively check child nodes
    if (node.ChildNodes && node.ChildNodes.length > 0) {
      const filteredChildren = filterDataByNodeTag(node.ChildNodes, filterTag, filterValues);
      if (filteredChildren.length > 0) {
        return true;
      }
    }

    return false;
  });
}
